module.exports = {
    SECRETS_API_URL: 'https://8pl9jud7tf.execute-api.us-east-1.amazonaws.com/prod/getSecrets',
    UPSERT_NOTIFICATION_API_URL: 'https://f7rmkof63e.execute-api.us-east-1.amazonaws.com/prod/upsertNotification',
    LIST_NOTIFICATIONS_API_URL: 'https://f7rmkof63e.execute-api.us-east-1.amazonaws.com/prod/listNotifications',
    DELETE_NOTIFICATION_API_URL: 'https://f7rmkof63e.execute-api.us-east-1.amazonaws.com/prod/deleteNotification',
    LIST_PRODUCTS_API_URL: 'https://f7rmkof63e.execute-api.us-east-1.amazonaws.com/prod/listProducts',
};